import React from 'react';

const TermsOfService = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-20 text-slate-800">
      <h1 className="text-4xl font-black mb-8 text-slate-900">Terms of Service</h1>
      
      <section className="mb-10">
        <h2 className="text-2xl font-bold mb-4">1. Acceptance of Terms</h2>
        <p className="leading-relaxed mb-4">
          By downloading or using the RetailMitra app, you agree to these terms. Our 
          services include barcode billing, inventory management, and QR ordering.
        </p>
      </section>

      <section className="mb-10">
        <h2 className="text-2xl font-bold mb-4">2. Subscription Plans</h2>
        <p className="leading-relaxed mb-4">
          We offer Free and Pro plans. The Pro plan includes a 7-day money-back 
          guarantee as outlined in our pricing section.
        </p>
      </section>

      <section className="mb-10">
        <h2 className="text-2xl font-bold mb-4">3. User Responsibility</h2>
        <p className="leading-relaxed mb-4">
          Users are responsible for maintaining the accuracy of their inventory and 
          customer credit (Udhar) records.
        </p>
      </section>
    </div>
  );
};

export default TermsOfService;